export const isDesktop = () => {
    const screenWidth = window.screen.width;    // make sure brave block fingerprinting is off
    return screenWidth > 1200;
};